/** Sonnerie type appel (Web Audio) — boucle jusqu'à stop(). */
export const createAlertRingtone = () => {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) {
        return { start: () => {}, stop: () => {} };
    }

    let ctx = null;
    let timer = null;
    let stopped = true;

    const beepPair = () => {
        if (stopped || !ctx) return;
        const now = ctx.currentTime;
        const gain = ctx.createGain();
        gain.gain.setValueAtTime(0.0001, now);
        gain.gain.exponentialRampToValueAtTime(0.35, now + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.95);
        gain.connect(ctx.destination);

        [440, 480].forEach((freq) => {
            const osc = ctx.createOscillator();
            osc.type = 'sine';
            osc.frequency.setValueAtTime(freq, now);
            osc.connect(gain);
            osc.start(now);
            osc.stop(now + 1);
        });
    };

    return {
        start: async () => {
            stopped = false;
            if (!ctx) ctx = new AudioCtx();
            if (ctx.state === 'suspended') {
                try {
                    await ctx.resume();
                } catch (_e) {
                    // ignore
                }
            }
            beepPair();
            timer = window.setInterval(beepPair, 2200);
        },
        stop: () => {
            stopped = true;
            if (timer) {
                window.clearInterval(timer);
                timer = null;
            }
            if (ctx) {
                try {
                    ctx.close();
                } catch (_e) {
                    // ignore
                }
                ctx = null;
            }
        },
    };
};
